import { useCustomMutation, HttpError, useNotification } from "@refinedev/core";
import { Box, Button, InputAdornment } from "@mui/material";
import { TeziLogoWithTextTP } from "../../assests/icons/tezi";
import { Link } from "react-router";
import { useForm } from "@refinedev/react-hook-form";
import { TextFieldElement } from "react-hook-form-mui";
import { useLayoutEffect } from "react";

type SendOtpPageProps = {
  onSuccess?: (session_id: string) => void;
};

export const SendOtpPage: React.FC<SendOtpPageProps> = ({ onSuccess }) => {
  const { handleSubmit, getValues, control } = useForm({
    defaultValues: {
      phoneNumber: localStorage.getItem("phoneNumber") || import.meta.env.VITE_PHONE_NUMBER || "",
    },
  });

  const { mutate: sendOtp } = useCustomMutation();
  const { open } = useNotification();
  
  useLayoutEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const errorMessage = params.get('error');
    
    if (errorMessage && open) {
      open({
        message: decodeURIComponent(errorMessage),
        type: "error",
      });
      
      // Remove the error parameter from URL
      params.delete('error');
      window.history.replaceState({}, '', window.location.pathname);
    }
  }, []);
  
  const onSubmit = () => {
    const phoneNumber = getValues("phoneNumber");
    sendOtp({
      url: `/auth/send-otp`,
      method: "post",
      values: {
        phone_number: `+91${phoneNumber}`
      },
      successNotification: (data) => {
        if (data?.data?.session_id) {
          onSuccess?.(data.data.session_id);
          localStorage.setItem("phoneNumber", phoneNumber);
          return {
            type: "success",
            message: data?.data?.message || "OTP sent successfully",
          };
        }
        return false;
      },
      errorNotification: (error?: HttpError) => {
        if (!error) return false;
        
        if (error.statusCode === 401) {
          return {
            type: "error",
            message: "Unauthorized access. Please try again.",
          };
        }
        window.location.href = '/login';
        return {
          type: "error",
          message: error?.message || "An error occurred",
        };
      }
    });
  };

  

  return (
    <Box sx={{ maxWidth: 400, margin: "auto" }}>
      <Box textAlign="center" mb={4}>
        <Link to="/">
          <TeziLogoWithTextTP width={200} height="auto"/>
        </Link>
      </Box>
      
      <Box component="form" onSubmit={handleSubmit(onSubmit)}>
        <TextFieldElement
          name="phoneNumber"
          control={control}
          type="tel"
          label="Phone Number"
          fullWidth
          sx={{ mb: 2 }}
          slotProps={{
            input: {
              startAdornment: <InputAdornment position="start">+91</InputAdornment>,
              inputMode: "numeric",
              inputProps: {
                maxLength: 10,
                pattern: "[0-9]{10}"
              }
            }
          }}
          rules={{
            required: "Phone number is required",
            pattern: {
              value: /^[0-9]{10}$/,
              message: "Please enter a valid 10-digit phone number"
            }
          }}
        />
        <Button fullWidth variant="contained" type="submit">
          Send OTP
        </Button>
      </Box>
    </Box>
  );
}; 